import type {
	LoggingService,
	Messages
} from '~/models/logging-service';

export class Logger {
	constructor (private readonly loggingService: LoggingService = console) {}

	log (...msgs: Messages): void {
		this.loggingService.log(...msgs);
	}

	error (...msgs: Messages): void {
		this.loggingService.error(...msgs);
	}

	info (...msgs: Messages): void {
		this.loggingService.info(...msgs);
	}

	warn (...msgs: Messages): void {
		this.loggingService.warn(...msgs);
	}

	success (...msgs: Messages): void {
		if (typeof this.loggingService.success === 'function') this.loggingService.success(...msgs);
		else this.loggingService.log(...msgs);
	}
}
